"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyInlineStyle_1 = require("../utils/applyInlineStyle");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * Set the List Item Style when all inner inline element have the same style
 * @param editor The editor instance
 * @param styleName Name of the style to apply to the list item
 * @param formatCallback callback to apply the style to each element
 */
function applyListItemStyleWrap(editor, styleName, formatCallback) {
    var parentNodes = [];
    applyInlineStyle_1.default(editor, function (element, isInnerNode) {
        formatCallback(element, isInnerNode);
        var parent = editor.getElementAtCursor('LI', element);
        if (parent && parentNodes.indexOf(parent) === -1) {
            parentNodes.push(parent);
        }
    });
    applyStyleToListItems(parentNodes, [styleName]);
}
exports.default = applyListItemStyleWrap;
/**
 * @internal
 * Checks if the parent element is a List Item, if it is, apply the style elements to the list item
 * @param parentNodes parentNodes to apply the style
 * @param styles styles to apply to the List Item Element
 */
function applyStyleToListItems(parentNodes, styles) {
    parentNodes.forEach(function (node) {
        if (roosterjs_editor_dom_1.safeInstanceOf(node, 'HTMLLIElement')) {
            roosterjs_editor_dom_1.setListItemStyle(node, styles);
        }
    });
}
//# sourceMappingURL=applyListItemWrap.js.map